// extracted by mini-css-extract-plugin
module.exports = {"accordionGroup":"FeaturedProductAccordion_accordionGroup__q0w3A","accordionContent":"FeaturedProductAccordion_accordionContent__CXfv4"};